import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import ViewVendorProfileScreen from '../component/ViewVendorProfileScreen';
import AppLoader from '../utils/AppLoader';
import { END_POINTS } from '../utils/service/EndPoints';
import { doVendorGET, doVendorPost } from '../utils/service';


class ViewVendorProfile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            isLoading: false,
            activeTab: 'profile',
            rechargePlan: null,
            rechargeLoading: false,
            rechargeError: '',
            rechargeSuccess: '',
            selectedMonth: '',
        }
    }
    componentDidMount() {
        this.setState({ isLoading: true })
        this.props.getProfileDetails("", (res) => {
            this.setState({ isLoading: false })
            if (res) {
                this.setState({ data: res })
                if (Number(res?.Vendor?.isSrmIp) === 1) {
                    this.loadRechargePlan();
                }
            }
        }, false)
    }

    loadRechargePlan = async (monthKey) => {
        this.setState({ rechargeLoading: true, rechargeError: '' });
        try {
            const month = monthKey != null ? monthKey : this.state.selectedMonth;
            const params = month ? { month } : undefined;
            const res = await doVendorGET(END_POINTS.VENDOR_RECHARGE_PLAN, params);
            if (res?.response_code === 0) {
                const plan = res.response || null;
                this.setState({
                    rechargePlan: plan,
                    selectedMonth: (plan && plan.selectedMonth) || month || '',
                    rechargeLoading: false,
                });
            } else {
                this.setState({
                    rechargeLoading: false,
                    rechargeError: res?.response_message || 'Unable to load recharge plan',
                });
            }
        } catch (err) {
            this.setState({
                rechargeLoading: false,
                rechargeError: err?.response_message || err?.message || 'Unable to load recharge plan',
            });
        }
    }

    onSelectRechargeMonth = (monthKey) => {
        const next = String(monthKey || '');
        this.setState({ selectedMonth: next }, () => {
            this.loadRechargePlan(next);
        });
    }

    updateCallPrice = async (callPrice) => {
        this.setState({ rechargeLoading: true, rechargeError: '', rechargeSuccess: '' });
        try {
            const res = await doVendorPost(END_POINTS.VENDOR_RECHARGE_PLAN_PRICE, { callPrice });
            if (res?.response_code === 0) {
                this.setState({ rechargeSuccess: res.response_message || 'Call price updated' });
                await this.loadRechargePlan();
            } else {
                this.setState({
                    rechargeLoading: false,
                    rechargeError: res?.response_message || res?.response || 'Unable to update price',
                });
            }
        } catch (err) {
            this.setState({
                rechargeLoading: false,
                rechargeError: err?.response_message || err?.message || 'Unable to update price',
            });
        }
    }

    rechargePlan = async (amount, note) => {
        this.setState({ rechargeLoading: true, rechargeError: '', rechargeSuccess: '' });
        try {
            const res = await doVendorPost(END_POINTS.VENDOR_RECHARGE_PLAN_RECHARGE, { amount, note });
            if (res?.response_code === 0) {
                this.setState({ rechargeSuccess: res.response_message || 'Recharge added successfully' });
                await this.loadRechargePlan();
            } else {
                this.setState({
                    rechargeLoading: false,
                    rechargeError: res?.response_message || res?.response || 'Unable to recharge',
                });
            }
        } catch (err) {
            this.setState({
                rechargeLoading: false,
                rechargeError: err?.response_message || err?.message || 'Unable to recharge',
            });
        }
    }

    updateRechargeSettings = async (settings) => {
        this.setState({ rechargeLoading: true, rechargeError: '', rechargeSuccess: '' });
        try {
            const res = await doVendorPost(END_POINTS.VENDOR_RECHARGE_PLAN_SETTINGS, settings);
            if (res?.response_code === 0) {
                this.setState({
                    rechargeSuccess: res.response_message || 'Settings updated',
                    rechargePlan: { ...(this.state.rechargePlan || {}), ...(res.response || {}) },
                    rechargeLoading: false,
                });
                await this.loadRechargePlan();
            } else {
                this.setState({
                    rechargeLoading: false,
                    rechargeError: res?.response_message || res?.response || 'Unable to update settings',
                });
            }
        } catch (err) {
            this.setState({
                rechargeLoading: false,
                rechargeError: err?.response_message || err?.message || 'Unable to update settings',
            });
        }
    }

    setActiveTab = (activeTab) => {
        this.setState({ activeTab, rechargeError: '', rechargeSuccess: '' });
        if (activeTab === 'recharge' && !this.state.rechargePlan) {
            this.loadRechargePlan();
        }
    }

    render() {
        const { isLoading } = this.state
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <ViewVendorProfileScreen
                            data={this.state.data}
                            activeTab={this.state.activeTab}
                            onTabChange={this.setActiveTab}
                            rechargePlan={this.state.rechargePlan}
                            rechargeLoading={this.state.rechargeLoading}
                            rechargeError={this.state.rechargeError}
                            rechargeSuccess={this.state.rechargeSuccess}
                            onUpdateCallPrice={this.updateCallPrice}
                            onRecharge={this.rechargePlan}
                            onUpdateRechargeSettings={this.updateRechargeSettings}
                            onRefreshRechargePlan={this.loadRechargePlan}
                            selectedMonth={this.state.selectedMonth}
                            onSelectRechargeMonth={this.onSelectRechargeMonth}
                        />
                    </div>
                </div>
                {(isLoading || this.state.rechargeLoading) && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getProfile: Actions.getProfileDetails(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getProfileDetails: Actions.getProfileAction
})(ViewVendorProfile));
